/**
 * authMessages.js - 인증 관련 UI 메시지
 *
 * AICC 로그인/로그아웃, 세션 만료, 인증 오류 등의 한글 UI 텍스트
 * 포함: 로그인 폼 라벨, 유효성 검사 메시지, 에러 메시지
 *
 * @see LoginPage, AuthProvider
 */
export const AUTH_MESSAGES = {
  // Login
  LOGIN_TITLE: '로그인',
  LOGIN_SUBTITLE: 'XYRO PLUG AICC',
  LOGIN_EMAIL_LABEL: '이메일',
  LOGIN_EMAIL_PLACEHOLDER: '이메일을 입력하세요',
  LOGIN_PASSWORD_LABEL: '비밀번호',
  LOGIN_PASSWORD_PLACEHOLDER: '비밀번호를 입력하세요',
  LOGIN_BUTTON: '로그인',
  LOGIN_LOADING: '로그인 중...',
  LOGIN_REMEMBER_ME: '로그인 정보 저장',

  // Validation
  VALIDATION_EMAIL_REQUIRED: '이메일을 입력해주세요.',
  VALIDATION_PASSWORD_REQUIRED: '비밀번호를 입력해주세요.',
  VALIDATION_INVALID_EMAIL: '올바른 이메일 형식이 아닙니다.',

  // Errors
  ERROR_INVALID_CREDENTIALS: '이메일 또는 비밀번호가 올바르지 않습니다.',
  ERROR_ACCOUNT_DISABLED: '비활성화된 계정입니다. 관리자에게 문의하세요.',
  ERROR_SESSION_EXPIRED: '세션이 만료되었습니다. 다시 로그인해주세요.',
  ERROR_NETWORK: '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  ERROR_UNAUTHORIZED: '접근 권한이 없습니다.',
  ERROR_TOKEN_REFRESH_FAILED: '토큰 갱신에 실패했습니다. 다시 로그인해주세요.',

  // Success
  SUCCESS_LOGIN: '로그인되었습니다.',
  SUCCESS_LOGOUT: '로그아웃되었습니다.',
  SUCCESS_PASSWORD_CHANGED: '비밀번호가 변경되었습니다.',

  // Logout
  LOGOUT_BUTTON: '로그아웃',
  LOGOUT_CONFIRM: '로그아웃 하시겠습니까?',

  // Password Change
  PASSWORD_CHANGE_TITLE: '비밀번호 변경',
  PASSWORD_CHANGE_BUTTON: '비밀번호 변경',
  PASSWORD_CURRENT_LABEL: '현재 비밀번호',
  PASSWORD_NEW_LABEL: '새 비밀번호',
  PASSWORD_CONFIRM_LABEL: '새 비밀번호 확인',
  PASSWORD_CURRENT_PLACEHOLDER: '현재 비밀번호를 입력하세요',
  PASSWORD_NEW_PLACEHOLDER: '새 비밀번호를 입력하세요 (8자 이상)',
  PASSWORD_CONFIRM_PLACEHOLDER: '새 비밀번호를 다시 입력하세요',
  ERROR_PASSWORD_CURRENT_REQUIRED: '현재 비밀번호를 입력해주세요.',
  ERROR_PASSWORD_NEW_REQUIRED: '새 비밀번호를 입력해주세요.',
  ERROR_PASSWORD_CONFIRM_REQUIRED: '비밀번호 확인을 입력해주세요.',
  ERROR_PASSWORD_TOO_SHORT: '비밀번호는 8자 이상이어야 합니다.',
  ERROR_PASSWORD_MISMATCH: '새 비밀번호가 일치하지 않습니다.',
  ERROR_PASSWORD_CURRENT_WRONG: '현재 비밀번호가 올바르지 않습니다.',
  ERROR_PASSWORD_CHANGE_FAILED: '비밀번호 변경에 실패했습니다.',

  // Session
  SESSION_CHECKING: '인증 확인 중...',

  // Session Timeout
  SESSION_TIMEOUT_TITLE: '세션 만료 예정',
  SESSION_TIMEOUT_MESSAGE: '장시간 활동이 없어 곧 자동으로 로그아웃됩니다.',
  SESSION_TIMEOUT_REMAINING: '남은 시간',
  SESSION_TIMEOUT_EXTEND_BUTTON: '세션 연장',
  SESSION_TIMEOUT_LOGOUT_BUTTON: '지금 로그아웃',
  SESSION_TIMEOUT_AUTO_LOGOUT: '자동 로그아웃되었습니다.',
};

export const USER_ROLES = {
  GLOBAL_ADMIN: 'GLOBAL_ADMIN',
  TENANT_ADMIN: 'TENANT_ADMIN',
  USER: 'USER',
};

export const ROLE_DISPLAY_NAMES = {
  [USER_ROLES.GLOBAL_ADMIN]: '전체 관리자',
  [USER_ROLES.TENANT_ADMIN]: '테넌트 관리자',
  [USER_ROLES.USER]: '사용자',
};

export default AUTH_MESSAGES;
